export default "__VITE_ASSET__Ba$G5PVN__"